import { clsx } from 'clsx';
import Modal from "../Modal";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Please use the Dialogs components. Example: `import { DialogInformative } from '@crehana/compass.ui';`
 */
var BaseDialog = function BaseDialog(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    onDismiss = _ref.onDismiss,
    onEscape = _ref.onEscape,
    _ref$disableEscapeKey = _ref.disableEscapeKeyDown,
    disableEscapeKeyDown = _ref$disableEscapeKey === void 0 ? false : _ref$disableEscapeKey,
    _ref$disableBackdropC = _ref.disableBackdropClick,
    disableBackdropClick = _ref$disableBackdropC === void 0 ? false : _ref$disableBackdropC,
    _ref$disabledScrollLo = _ref.disabledScrollLock,
    disabledScrollLock = _ref$disabledScrollLo === void 0 ? false : _ref$disabledScrollLo;
  return /*#__PURE__*/_jsx(Modal, {
    role: "dialog",
    className: "tw-flex tw-justify-center tw-place-items-center",
    open: open,
    onDismiss: onDismiss,
    onEscape: onEscape,
    disableEscapeKeyDown: disableEscapeKeyDown,
    disableBackdropClick: disableBackdropClick,
    disabledScrollLock: disabledScrollLock,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx('tw-rounded tw-max-h-[90vh]',
      // SPACING
      'tw-bg-neutral-light-100 tw-shadow-01',
      // COLORS
      'tw-overflow-y-auto', className),
      style: style,
      children: children
    })
  });
};
export default BaseDialog;